// extracted by mini-css-extract-plugin
export default {"footerContainer":"Footer_footerContainer__NI2QJ","footerLogo":"Footer_footerLogo__djMY9","footerText":"Footer_footerText__+GIpG"};